import type { AxiosError, AxiosRequestConfig } from 'axios'
import Axios from 'axios'
import { ElLoading } from 'element-plus'
import * as QueryString from 'qs'

export function initAxios(baseUrl: string) {
  Axios.defaults.timeout = 60000
  Axios.defaults.baseURL = baseUrl
  Axios.defaults.paramsSerializer = params => QueryString.stringify(params, { arrayFormat: 'repeat' })
  Axios.interceptors.request.use((config) => {
    if (config.autoLoading) {
      ElLoading.service()
    }
    return config
  })
  Axios.interceptors.response.use(
    (response) => {
      if (response.config.autoLoading) {
        ElLoading.service().close()
      }
      return response
    },
    async (error: AxiosError) => {
      console.debug('axios failed:', error.isAxiosError ? error.response : error.stack || error)
      const config: AxiosRequestConfig = error.config || {}
      if (config.autoLoading) {
        ElLoading.service().close()
      }
      return Promise.reject(error)
    },
  )
}
